import { render, staticRenderFns } from "./ProAttr.vue?vue&type=template&id=c1cb4cae&scoped=true"
import script from "./ProAttr.vue?vue&type=script&lang=js"
export * from "./ProAttr.vue?vue&type=script&lang=js"
import style0 from "./ProAttr.vue?vue&type=style&index=0&id=c1cb4cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cb4cae",
  null
  
)

export default component.exports